import React, { createContext, useEffect, useState } from "react"
import { preparePreviewPage } from "../utils/preparePageDataBrowser"

export const PageContext = createContext()

export const PageProvider = props => {
  const [previewData, setPreviewData] = useState(null)
  const [isLoading, setIsLoading] = useState(!!process.env.PREVIEW_ENABLED)
  useEffect(() => {
    const fetchData = async () => {
      const urlParams = new URLSearchParams(props.location.search)
      const value = await preparePreviewPage(
        urlParams.get("parentId"),
        urlParams.get("pageId")
      )
      setPreviewData(value)
      setIsLoading(false)
    }
    fetchData()
  }, [props.location.search])

  if (!process.env.PREVIEW_ENABLED) {
    return (
      <PageContext.Provider value={props.data}>
        {props.children}
      </PageContext.Provider>
    )
  }

  if (isLoading && process.env.PREVIEW_ENABLED) {
    return <div>loading</div>
  }

  return (
    <PageContext.Provider value={previewData}>
      {props.children}
    </PageContext.Provider>
  )
}
